var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileIco(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2971_22587",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 69,
    height: 68
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4997 62.3332C53.0026 62.3332 54.4439 61.7361 55.5066 60.6734C56.5693 59.6107 57.1663 58.1694 57.1663 56.6665V22.6665L40.1663 5.6665H17.4997C15.9968 5.6665 14.5554 6.26353 13.4927 7.32623C12.43 8.38894 11.833 9.83028 11.833 11.3332V56.6665C11.833 58.1694 12.43 59.6107 13.4927 60.6734C14.5554 61.7361 15.9968 62.3332 17.4997 62.3332H51.4997ZM37.333 11.3332L51.4997 25.4998H37.333V11.3332ZM20.333 22.6665H28.833V28.3332H20.333V22.6665ZM20.333 33.9998H48.6663V39.6665H20.333V33.9998ZM20.333 45.3332H48.6663V50.9998H20.333V45.3332Z",
    fill: "#0D003B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2971_22587)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 72,
    height: 72,
    fill: "#2E66C0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIco);
export default __webpack_public_path__ + "static/media/fileIco.1bd91bdc2f21a799c9f043de41d3ebd5.svg";
export { ForwardRef as ReactComponent };